import window, { URLSearchParams, URL, location, document, navigator, matchMedia } from 'window';
import fetch from 'fetch';

(function () {
	const QUERY_ARG_BASE = 'lkdmsIframeConnector';
	const QUERY_ARG_AUTH_SUCCESS = QUERY_ARG_BASE + '_Success';
	const QUERY_ARG_AUTH_FAIL = QUERY_ARG_BASE + '_Fail';
	const QUERY_ARG_DEBUG = QUERY_ARG_BASE + '_Debug';
	const queryParams = new URLSearchParams(window.location.search);
	
	const SESSION_STORAGE_KEY = 'ofrLkdmsIframe';
	const getState = () => (JSON.parse(window.sessionStorage.getItem(SESSION_STORAGE_KEY)));
	const mergeState = (payload) => {
		const state = getState();
		const newState = {
			...(state || {}),
			...payload,
		};
		window.sessionStorage.setItem(SESSION_STORAGE_KEY, JSON.stringify(newState));
	};
	const touchState = () => (mergeState({}));

	const getCurrentRelativeUrl = () => (location.pathname + location.search + location.hash);
	const trace = (message, data = null) => {
		const state = getState();
		if (!state || !state.IsDebugMod) {
			console.log('Trace:', state); // TODO: comment after DEV and uncomment return line
			// return;
		}

		if (data) {
			console.log(`ofr-sync-bridge: ${message}`, data);
		} else {
			console.log(`ofr-sync-bridge: ${message}`);
		}
	};

	const topics = {
		AUTH_DONE: 'oldlkdms_frame_authentication_completed',
		AUTH_ALARM: 'oldlkdms_frame_authentication_alarm',
		AUTH_REQUEST: 'oldlkdms_frame_authentication_request',
		URL_CHANGED: 'oldlkdms_frame_location_update',
		URL_CHANGE_REQUEST: 'oldlkdms_frame_location_update_request',
		FRAME_SIZE_SYNC: 'frame_resizer',
		SB_PAYMENT_ACTION: 'sb_payment_action',
		GO_TO_MAIN_PAGE: 'redirect_to_main_page',
		GO_TO_ONLINE_CONSULTATIONS_PAGE: 'redirect_to_online_consultations_page',
		OPEN_CHAT_ACTION: 'open_chat_action',
		SCROLL_UP_ACTION: 'scroll_page_up_action',
		SCROLL_TO_VIEW_ACTION: 'scroll_page_to_view_action',
		CALLBACK_TO_MOBILE_APP: 'callback_to_mobile_app',
		PARENT_AVAIL_HEIGHT: 'parent_avail_height',
	};

	function shout (topic, extraPayload = {}, targetWindow = null) {
		if (!Object.values(topics).includes(topic)) {
			console.error('Unknown topic inside `ofr-x-lkdms-iframe`');
			return;
		}

		const finalPayload = {
			topic,
			payload: {
				...extraPayload,
			},
		};

		// parent обязан быть. Допускаем его отсутствие для отладочных целей
		const win = targetWindow || window.parent || window;
		trace('Отправляю postMessage:', finalPayload);

		win.postMessage(finalPayload, '*');
	}

	function shoutAuthCompleted (isSuccess, error, targetWindow = null) {
		const payload = {};
		payload['isSuccess'] = isSuccess;
		if (!isSuccess) {
			payload['error'] = error;
		}
		shout(topics.AUTH_DONE, payload, targetWindow);
	}

	function shoutAuthAlarm () {
		shout(topics.AUTH_ALARM);
	}

	function shoutUrlChanged (newUrl) {
		shout(topics.URL_CHANGED, { url: newUrl });
	}

	function shoutSelfIframeSize (height) {
		shout(topics.FRAME_SIZE_SYNC, { contentHeight: height });
	}

	function shoutSbPaymentEvent (url) {
		shout(topics.SB_PAYMENT_ACTION, { paymentUrl: url });
	}

	function shoutGoToMainPage () {
		shout(topics.GO_TO_MAIN_PAGE);
	}

	function shoutGoToTelemedPage () {
		shout(topics.GO_TO_ONLINE_CONSULTATIONS_PAGE);
	}

	function shoutOpenChatAction () {
		shout(topics.OPEN_CHAT_ACTION);
	}

	function shoutScrollPageUpAction () {
		shout(topics.SCROLL_UP_ACTION);
	}

	function shoutScrollToViewAction (data) {
		shout(topics.SCROLL_TO_VIEW_ACTION, {
			boundingClientRectTop: data.top,
			boundingClientRectHeight: data.height,
		});
	}

	function shoutMobileAppCallbackAction (data) {
		const {callbackName, param} = data;
		const params = {callbackName: callbackName || ''};
		if (param) {
			params.param = param;
		}
		shout(topics.CALLBACK_TO_MOBILE_APP, params);
	}

	let isOfrIFrame = Boolean(getState());

	// Признак того, что открытие страницы было инициировано родительским сайтом
	let isNavigatedFromParent = false;

	// 1. Обогащение состояния по query-параметрам
	for (const [key] of queryParams.entries()) {
		if (key.startsWith(QUERY_ARG_BASE)) {
			isNavigatedFromParent = true;

			if (!isOfrIFrame) {
				touchState();
				isOfrIFrame = true;
			}

			if (key === QUERY_ARG_DEBUG) {
				mergeState({IsDebugMod: true});
			}
		}
	}

	// 2. Если мы не во фрейме ОФР - выходим
	if (!isOfrIFrame) {
		return;
	}

	trace('Сайт открыт в режиме iframe для ОФР');

	// 3. Ставим в элемент body якорный class для активации специфичных стилей.
	document.body.classList.add('ofr-x-lkdms-iframe');

	// 4. Обрабатываем из query-параметров признаки состоявшейся аутентификации при наличии
	{
		const authSuccessParameter = queryParams.get(QUERY_ARG_AUTH_SUCCESS);
		const authFailParameter = queryParams.get(QUERY_ARG_AUTH_FAIL);
		const isAuthenticationResultInUrl = authSuccessParameter || authFailParameter;

		if (isAuthenticationResultInUrl) {
			const isSuccess = Boolean(authSuccessParameter);
			trace(`Получен признак аутентификации: ${isSuccess ? 'Успех' : 'Провал'}`);
			shoutAuthCompleted(isSuccess, authFailParameter);
		}

		// Вычищаем query-параметры модуля из url
		const url = new URL(window.location.href);
		for (const [key] of queryParams.entries()) {
			if (key.startsWith(QUERY_ARG_BASE)) {
				url.searchParams.delete(key);
			}
		}
		window.history.replaceState(null, '', url);
	}

	// 5. Инициализация обработчиков входящих postMessage
	{
		const allowedOfrOrigins = [
			'my.rgs.ru',
			'my-dev.rgs.ru',
			'my-tst01.rgs.ru',
			'my-stage.rgs.ru',
			'lkdms-dev.rgs.ru', // Старое, скоро будет полностью заменен на my-dev.rgs.ru
			'lkdms-tst01.rgs.ru', // Старое, скоро будет полностью заменен на my-tst01.rgs.ru
			'lkdms-stage.rgs.ru', // Старое, скоро будет полностью заменен на my-stage.rgs.ru
			'local.test.rgs.ru',
			'localhost',
		];
		const topicHandlers = {};
		topicHandlers[topics.AUTH_REQUEST] = (event, payload) => {
			const url = '/cmsapi/lk/dms/partnerEmployee/auth';
			const body = {
				'token': payload.token,
			};

			trace(`Выполняю запрос бесшовной аутентификации ${url}, body:`, body);
			return fetch(url, {
				method: 'post',
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
				},
				body: JSON.stringify(body),
			})
			.then((response) => {
				trace(`Запрос бесшовной аутентификации выполнен со статусом: ${response.status}`);
				const isSuccess = response.ok;
				shoutAuthCompleted(isSuccess, isSuccess ? null : response.status, event.source);
			})
			.catch((error) => {
				trace(`Запрос бесшовной аутентификации завершился ошибкой: ${error.message}`);
				shoutAuthCompleted(false, error.message, event.source);
			});
		};
		topicHandlers[topics.URL_CHANGE_REQUEST] = (event, payload) => {
			const newUrl = payload.url;
			trace(`Обновляю URL по внешнему запросу на: ${newUrl}`);
			window.location = newUrl;
		};
		topicHandlers[topics.PARENT_AVAIL_HEIGHT] = (event, payload) => {
			const {viewportHeight} = payload;
			trace(`Get viewport height from parent: ${viewportHeight}`);
			const isMobileAlikeDevice = matchMedia('(max-width: 560px)').matches;
			if (isMobileAlikeDevice) {
				const heightString = `${viewportHeight}`;
				window.localStorage.setItem('mobile-height-for-iframe', heightString);
			}
		};

		window.addEventListener('message', (event) => {
			const { topic, payload } = event.data;
			const isMyMessage = event.source === window;
			if (!topic || isMyMessage) {
				return;
			}

			// Проверка легитимности отправителя
			if (!allowedOfrOrigins.some(x => event.origin.includes(x))) {
				trace(`Получено событие '${topic}', но отправитель неприемлем`);
				return;
			}

			trace(`Получено событие '${topic}'`);
			topic && topicHandlers[topic](event, payload);
		});
	}

	// 6. Инициализируем глобальный объект, с нужным функционалом для иных модулей сайта
	window['__ofr-x-lkdms-iframe-sync-bridge__'] = {
		escalateAuthenticationAlarm: () => {
			shoutAuthAlarm();
		},
		sendSbPaymentMessage: (url) => {
			shoutSbPaymentEvent(url);
		},
		sendGoToMainPageMessage: () => {
			shoutGoToMainPage();
		},
		sendGoToTelemedPageMessage: () => {
			shoutGoToTelemedPage();
		},
		sendOpenChatMessage: () => {
			shoutOpenChatAction();
		},
		sendScrollPageUpMessage: () => {
			shoutScrollPageUpAction();
		},
		sendScrollToViewMessage: (data) => {
			shoutScrollToViewAction(data);
		},
		sendMobileAppCallbackMessage: (data) => {
			shoutMobileAppCallbackAction(data);
		},
	};

	// 7. Обработка события изменения страницы для оповещения родительского окна (нового сайта)
	let lastReportedUrl = undefined;
	const tryReportUrlChange = (byEvent) => {
		const url = getCurrentRelativeUrl();
		if (url !== lastReportedUrl) {
			shoutUrlChanged(url);
			lastReportedUrl = url;
		} else {
			// eslint-disable-next-line max-len
			trace(`Выстрелило событие '${byEvent}' (${url}), но не пошлю на верх, т.к. считаю это сообщение будет дубликатом`);
		}
	};

	window.addEventListener('popstate', () => (tryReportUrlChange('popstate')));
	window.addEventListener('hashchange', () => (tryReportUrlChange('hashchange')));

	if (!isNavigatedFromParent) {
		// При загрузке страницы шлем сразу. Иначе не будет события, например, при переходе из "Корп. ДМС" на "Мой профиль"
		tryReportUrlChange('initial');
	}

	// 8. Отправка в родительский сайт размера фрейма (себя). ~Поведение iframe-resizer
	{
		const bodyElement = document.getElementsByTagName('body')[0];
		const isPwa = navigator.standalone || matchMedia('(display-mode: standalone)').matches;
		let _heightState = 0;
		const syncBodySize = function () {
			const valueInStorage = window.localStorage.getItem('mobile-height-for-iframe');
			const heightValue = valueInStorage ? Number(valueInStorage) : 0;
			const isMobileAlikeDevice = matchMedia('(max-width: 560px)').matches;
			if (isPwa) {
				const parentElementsSum = isMobileAlikeDevice ? 256 : 80;
				const calculatedScreenHeight = window.screen.availHeight - parentElementsSum;
				const availableScreenHeight
					= heightValue && heightValue > 0 ? heightValue - 175 : calculatedScreenHeight;
				const currentHeight = bodyElement.offsetHeight;
				const isUpdated = currentHeight !== _heightState;
				if (isUpdated) {
					const heightToState = currentHeight > availableScreenHeight
						? currentHeight : availableScreenHeight;
					shoutSelfIframeSize(heightToState);
					_heightState = heightToState;
				}
			} else {
				const currentHeight = bodyElement.offsetHeight;
				const isUpdated = currentHeight !== _heightState;
				if (isUpdated) {
					shoutSelfIframeSize(currentHeight);
					_heightState = currentHeight;
				}
			}
		};

		setInterval(syncBodySize, 100);
		trace('Включена синхронизации размера body');
	}
}());